import { ReactElement } from 'react';
import OrgList from './components/OrgList';
import { HeadTag } from 'shared/components';

const LoginPage = (): ReactElement => (
  <>
    <HeadTag title="Organisation" />
    <OrgList />
  </>
);

export default LoginPage;
